import(/* webpackMode: "eager" */ "/root/apps/blogtostart/src/app/global-error.tsx");
